import _ from 'lodash';
import moment from 'moment';

export default {
	statistics(rawData) {
		if (!_.isNil(rawData) && rawData.length > 0) {
			const stats = [];

			rawData.forEach((stat) => {
				if (_.isNil(stat.date) || _.isNil(stat.metrics)) {
					return;
				}

				stats.push({
					name: moment(stat.date).format('MMM DD'),
					blocks: stat.metrics.blocks,
					bounce_drops: stat.metrics.bounce_drops,
					bounces: stat.metrics.bounces,
					clicks: stat.metrics.clicks,
					deferred: stat.metrics.deferred,
					delivered: stat.metrics.delivered,
					invalid_emails: stat.metrics.invalid_emails,
					opens: stat.metrics.opens,
					processed: stat.metrics.processed,
					requests: stat.metrics.requests,
					spam_report_drops: stat.metrics.spam_report_drops,
					spam_reports: stat.metrics.spam_reports,
					unique_clicks: stat.metrics.unique_clicks,
					unique_opens: stat.metrics.unique_opens,
					unsubscribe_drops: stat.metrics.unsubscribe_drops,
					unsubscribes: stat.metrics.unsubscribes
				});
			});

			return stats;
		}

		return rawData;
	},

	// params format should be result from statistics
	summary(statistics) {
		const summary = {
			requests: 0,
			bounces: {
				total: 0,
				percentage: 0
			},
			clicks: {
				total: 0,
				percentage: 0
			},
			delivered: {
				total: 0,
				percentage: 0
			},
			opens: {
				total: 0,
				percentage: 0
			},
			spam_reports: {
				total: 0,
				percentage: 0
			}
		};

		statistics.forEach((stat) => {
			summary.requests += stat.requests;
			summary.bounces.total += stat.bounces;
			summary.clicks.total += stat.clicks;
			summary.delivered.total += stat.delivered;
			summary.opens.total += stat.opens;
			summary.spam_reports.total += stat.spam_reports;
		});

		summary.bounces.percentage = this._calculatePrecentage(summary.bounces.total, summary.requests);
		summary.clicks.percentage = this._calculatePrecentage(summary.clicks.total, summary.requests);
		summary.delivered.percentage = this._calculatePrecentage(summary.delivered.total, summary.requests);
		summary.opens.percentage = this._calculatePrecentage(summary.opens.total, summary.requests);
		summary.spam_reports.percentage = this._calculatePrecentage(summary.spam_reports.total, summary.requests);

		return summary;
	},

	_calculatePrecentage(total, count) {
		if (total === 0) {
			return 0;
		}
		return parseFloat((total / count) * 100).toFixed(2);
	}
};



// WEBPACK FOOTER //
// ./src/helpers/graph.js